import TabsComp from "../../components/TabsComp";
import styles from "./Section2.module.css";

const phases = [
  {
    title: "Initial Consultation",
    text: "We start by understanding your goals, target audience, and design preferences through an in-depth consultation.",
  },
  {
    title: "Design Mockups",
    text: "We create custom design mockups that align with your brand's identity for your approval.",
  },
  {
    title: "Development",
    text: "Our developers turn the approved designs into a fully functional WordPress site, ensuring it's mobile-responsive and SEO-friendly.",
  },
  {
    title: "Content Integration",
    text: "We add your content, including text, images, and multimedia, ensuring it's optimized for search engines.",
  },
  {
    title: "Testing & Quality Assurance",
    text: "The site undergoes rigorous testing for functionality, responsiveness, and speed to ensure a flawless user experience.",
  },
];

export default function Section2() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.contentPanel}>
          <span className={styles.kicker}>WordPress Website Development</span>
          <h2>
            WordPress website development tailored to your business needs and
            goals.
          </h2>

          <div className={styles.tabsWrap}>
            <TabsComp
              items={phases}
              initialActiveIndex={0}
              showNumbers={true}
              showNavigation={true}
              showIcons={false}
              ariaLabel="Website development process"
            />
          </div>
        </div>

        <div className={styles.mediaPanel}>
          <img
            src="/img/marketing/wordpress-development.webp"
            alt="Custom website development showcase"
            className={styles.showcaseImage}
          />
        </div>
      </div>
    </section>
  );
}
